"use strict";

if (process.env.NODE_ENV === "production") {
  module.exports = require("./prop-type-shims");
} else {
  module.exports = require("./prop-types");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian/_prop-types/index.js
// module id = 71
// module chunks = 0